import { SharedIcon } from "~/react/components/shared/shared-icon";
import { useInviteFriendModalStore } from "~/js/stores/invite-friend-modal-store";
import { useInviteFriendStore } from "~/js/stores/invite-friend-store";
import { useEffect } from "react";

const INVITE_FRIEND_URL = '/umbraco/api/savedColours/getInviteFriendForm';

export function InviteFriendBtn( { data } ) {
  const openModal = useInviteFriendModalStore((state) => state.openModal);
  const { recaptchaSiteKey } = data || {};
  const setRecaptchaSiteKey = useInviteFriendStore((state) => state.setRecaptchaSiteKey);

  useEffect(() => {
    if(!!recaptchaSiteKey) {
      setRecaptchaSiteKey(recaptchaSiteKey);
    }
  }, [recaptchaSiteKey, setRecaptchaSiteKey]);

  const clickHandler = () => {
      openModal(INVITE_FRIEND_URL);
  }

  return (
      <button
        type="button"
        className="hub-header__invite-cta button grey"
        aria-label="Invite a friend"
        onClick={(e) => clickHandler(e)}
      >
        <SharedIcon iconName="#icon-user" />
        <span>Invite a friend</span>
      </button>
  );
}
